import { render, staticRenderFns } from "./Magnets.vue?vue&type=template&id=2a7e53b8"
import script from "./Magnets.vue?vue&type=script&lang=js"
export * from "./Magnets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports